<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Hawaii Environmental Health Administration Hazard Evaluation and Emergency Response Office"
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop class="grid grid-cols-1 gap-10">
        <PublicLandingOnlineServices
          class=""
          title="Internal Services"
          body="The iHEER System provides online employee access to Hazard Evaluation and Emergency Response Office inquiries, incidents, HEPCRA facilities, and sites."
          hide-register
        ></PublicLandingOnlineServices>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { computed, defineComponent } from "vue";

import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import { routeNames } from "@/routes";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore, routeNames };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    MdrnFooter,
    NoneFoundFlag,
    LogoutButton,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #111240; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/bg-iheer.jpg");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
